// create a stock contact info page here 

import React from 'react';

function Contact() {
  return (
    <div className="contact">
      <section className="contact-content">
        <h2>Please send inquiries to contact@moolmittattoo.com</h2>
      </section>
    </div>
  );
}

export default Contact;